import { lazy } from 'react';

const TruckModalConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: '/Truck/modal',
      component: lazy(() => import('../TruckDialog')),
    },
  ],
};

export default TruckModalConfig;
